import { render, staticRenderFns } from "./password-confirmation-input.vue?vue&type=template&id=3ecfc2c9"
import script from "./password-confirmation-input.vue?vue&type=script&lang=js"
export * from "./password-confirmation-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports